// Broadcast listings (Where to Watch) via the espn-api Netlify function.
const BASES = [
  '/.netlify/functions/espn-api',
  'https://bettoradvantage.com/.netlify/functions/espn-api',
];

export const fetchBroadcasts = async (espnSport, dates) => {
  for (const base of BASES) {
    try {
      const url = `${base}?sport=${encodeURIComponent(espnSport)}&type=broadcasts${dates ? `&dates=${encodeURIComponent(dates)}` : ''}`;
      const response = await fetch(url);
      if (!response.ok) continue;
      const data = await response.json();
      if (data && Array.isArray(data.events)) return data.events;
    } catch (e) {
      // try the next base
    }
  }
  throw new Error('Broadcast listings unavailable');
};
